import { AgentsSection } from '../components/AgentsSection';

export function SettingsAgents() {
  return <AgentsSection />;
}
